import Page from './Page';
import Component from 'vue-class-component';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';

import template from './GratuityList.vue.html';
import GratuityCarousel from '../common/gratuity/GratuityCarousel.vue';
import { GratuityStaffImage } from '../common/gratuity/Types';

@Component({
    template,
    components: { TabBar, HeaderComponent, GratuityCarousel },
})
export default class GratuityList extends Page {
    showNotice = false;
    pickedUpImagesInGeneral: GratuityStaffImage[] = [];
    target: string = 'content';

    async created() {
        window.scroll(0, 0);
        await this.app.fetchGratuities();

        this.pickedUpImagesInGeneral = (this.app.gratuity?.staffs ?? []).map(
            (staff) => {
                return {
                    id: staff.id,
                    name: staff.texts.staff_name,
                    filepath: staff.image_urls ? staff.image_urls[0] : null,
                };
            }
        );
    }

    setGratuityStaff(staff_id: number) {
        this.app.updateQuery({
            page: 'GratuityDetail',
            staff_id,
        });
    }
}
